import { Layout, TrafficSign as TrafficSignComponent } from "components"
export const TrafficSign = () => {
 return (
  <Layout>
   <TrafficSignComponent />
  </Layout>
 )
}
